export enum NoteImageParentKind {
  PERSONAL = 'personal',
  PROJECT = 'project'
}

/** The first four are the backend's `code` values (backend docs/note-image-attachments.md §7). */
export enum NoteImageErrorCode {
  UNSUPPORTED_TYPE = 'note_image_unsupported_type',
  TOO_LARGE = 'note_image_too_large',
  NOT_UPLOADED = 'note_image_not_uploaded',
  LIMIT_REACHED = 'note_image_limit_reached',
  FEATURE_UNAVAILABLE = 'feature_unavailable',
  FORBIDDEN = 'forbidden',
  TITLE_REQUIRED = 'title_required',
  UPLOAD_FAILED = 'upload_failed'
}

export enum NoteImageMimeType {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  GIF = 'image/gif',
  WEBP = 'image/webp',
  HEIC = 'image/heic',
  HEIF = 'image/heif'
}

export enum NoteImageAvailability {
  UNKNOWN = 'unknown',
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable'
}

export enum NoteImageDisplayState {
  LOADING = 'loading',
  READY = 'ready',
  UNAVAILABLE = 'unavailable',
  /** A remote image an earlier editor stored: kept in the body, never loaded. */
  EXTERNAL = 'external'
}

/** The backend's attachment kinds: each has its own endpoints and reference scheme. */
export enum NoteAttachmentKind {
  IMAGE = 'image',
  AUDIO = 'audio',
  PDF = 'pdf'
}

/** TipTap node names every project-note editor must define (backend contract §14). */
export enum ProjectNoteMediaNode {
  AUDIO = 'audio',
  PDF = 'pdf'
}
